import { render, staticRenderFns } from "./newBusiForm.vue?vue&type=template&id=3cde21ee&scoped=true"
import script from "./newBusiForm.vue?vue&type=script&lang=js"
export * from "./newBusiForm.vue?vue&type=script&lang=js"
import style0 from "./newBusiForm.vue?vue&type=style&index=0&id=3cde21ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde21ee",
  null
  
)

export default component.exports